[
  {
    "environments" : [
      "accept",
      "dev",
      "kt",
      "pcs",
      "prod",
      "sc"
    ],
    "organisation" : {
      "fullName" : "Adrichem Transport B.V.",
      "shortName" : "ADRICHEM",
      "emailAddress" : "afval@adrichem.com",
      "address" : "Lijndenweg 7",
      "city" : "Beverwijk",
      "zipCode" : "1948 ND",
      "countryUnCode" : "NL",
      "countryName" : "Netherlands",
      "phoneNumber" : "+31-251-229144",
      "faxNumber" : "+31-251-221858",
      "contact" : "Service Desk",
      "ensEnabled" : false,
      "cargoImportEnabled" : false,
      "cargoImportEnabledByDefault" : false
    },
    "vihbNumber" : "500435",
    "collectorNumber" : "07072",
    "annexPerPort" : {
      "NLAMS" : [
        5
      ]
    },
    "authorityIdPerPort" : {
      "NLAMS" : "ADR",
      "NLBZM" : "ADRICHEM",
      "NLHAR" : "ADRICHEM",
      "NLITR" : "ADRICHEM",
      "NLKAM" : "ADRICHEM",
      "NLLAN" : "ADRICHEM",
      "NLLWR" : "ADRICHEM",
      "NLMSB" : "ADRICHEM",
      "NLOMD" : "ADRICHEM",
      "NLRTM" : "ADRICHEM",
      "NLSCE" : "ADRICHEM",
      "NLURK" : "ADRICHEM",
      "NLVEN" : "ADRICHEM",
      "NLWKD" : "ADRICHEM",
      "NLWTE" : "ADRICHEM"
    }
  },
  {
    "environments" : [
      "accept",
      "dev",
      "kt",
      "pcs",
      "prod",
      "sc"
    ],
    "organisation" : {
      "fullName" : "Amsterdam Port Services B.V.",
      "shortName" : "APS",
      "emailAddress" : "info@aps.nl",
      "address" : "Petroleumhavenweg 48",
      "city" : "Amsterdam",
      "zipCode" : "1041 AC",
      "countryUnCode" : "NL",
      "countryName" : "Netherlands",
      "phoneNumber" : "+31-20-6130225",
      "faxNumber" : "+31-20-6118723",
      "contact" : "APS user",
      "ensEnabled" : false,
      "cargoImportEnabled" : false,
      "cargoImportEnabledByDefault" : false
    },
    "annexPerPort" : {},
    "authorityIdPerPort" : {
      "NLAMS" : "APS",
      "NLBZM" : "APS",
      "NLHAR" : "APS",
      "NLITR" : "APS",
      "NLKAM" : "APS",
      "NLLAN" : "APS",
      "NLLWR" : "APS",
      "NLMSB" : "APS",
      "NLOMD" : "APS",
      "NLRTM" : "APS",
      "NLSCE" : "APS",
      "NLURK" : "APS",
      "NLVEN" : "APS",
      "NLWKD" : "APS",
      "NLWTE" : "APS"
    }
  },
  {
    "environments" : [
      "sc"
    ],
    "organisation" : {
      "fullName" : "ATM SC voor Cor K.",
      "shortName" : "ATM",
      "emailAddress" : "info@atmmoerdijk.nl",
      "address" : "Vlasweg 12",
      "city" : "Moerdijk",
      "zipCode" : "4785 PW",
      "countryUnCode" : "NL",
      "countryName" : "Netherlands",
      "phoneNumber" : "+31-168-389289",
      "faxNumber" : "+31-168-389270",
      "contact" : "Danny van Leeuwen",
      "ensEnabled" : false,
      "cargoImportEnabled" : false,
      "cargoImportEnabledByDefault" : false
    },
    "vihbNumber" : "501809",
    "collectorNumber" : "ATM01",
    "annexPerPort" : {
      "NLBZM" : [
        1,
        2,
        4,
        5,
        6
      ],
      "NLHAR" : [
        1,
        2,
        4,
        5,
        6
      ],
      "NLITR" : [
        1,
        2,
        4,
        5,
        6
      ],
      "NLKAM" : [
        1,
        2,
        4,
        5,
        6
      ],
      "NLLAN" : [
        1,
        2,
        4,
        5,
        6
      ],
      "NLLWR" : [
        1,
        2,
        4,
        5,
        6
      ],
      "NLMSB" : [
        1,
        2,
        4,
        5,
        6
      ],
      "NLOMD" : [
        1,
        2,
        4,
        5,
        6
      ],
      "NLRTM" : [
        1,
        2,
        4,
        5,
        6
      ],
      "NLURK" : [
        1,
        2,
        4,
        5,
        6
      ],
      "NLVEN" : [
        1,
        2,
        4,
        5,
        6
      ],
      "NLWKD" : [
        1,
        2,
        4,
        5,
        6
      ],
      "NLWTE" : [
        1,
        2,
        4,
        5,
        6
      ]
    },
    "authorityIdPerPort" : {
      "NLBZM" : "ATM",
      "NLHAR" : "ATM",
      "NLITR" : "ATM",
      "NLKAM" : "ATM",
      "NLLAN" : "ATM",
      "NLLWR" : "ATM",
      "NLMSB" : "ATM",
      "NLOMD" : "ATM",
      "NLRTM" : "ATM",
      "NLSCE" : "ATMG",
      "NLURK" : "ATM",
      "NLVEN" : "ATM",
      "NLWKD" : "ATM",
      "NLWTE" : "ATM"
    }
  },
  {
    "environments" : [
      "accept",
      "dev",
      "pcs",
      "prod"
    ],
    "organisation" : {
      "fullName" : "ATM",
      "shortName" : "ATM1",
      "emailAddress" : "info@atmmoerdijk.nl",
      "address" : "Vlasweg 12",
      "city" : "Moerdijk",
      "zipCode" : "4785 PW",
      "countryUnCode" : "NL",
      "countryName" : "Netherlands",
      "phoneNumber" : "+31-168-389289",
      "faxNumber" : "+31-168-389270",
      "contact" : "Danny van Leeuwen",
      "ensEnabled" : false,
      "cargoImportEnabled" : false,
      "cargoImportEnabledByDefault" : false
    },
    "vihbNumber" : "501809",
    "collectorNumber" : "ATM01",
    "annexPerPort" : {
      "NLBZM" : [
        1,
        2,
        4,
        5,
        6
      ],
      "NLHAR" : [
        1,
        2,
        4,
        5,
        6
      ],
      "NLITR" : [
        1,
        2,
        4,
        5,
        6
      ],
      "NLKAM" : [
        1,
        2,
        4,
        5,
        6
      ],
      "NLLAN" : [
        1,
        2,
        4,
        5,
        6
      ],
      "NLLWR" : [
        1,
        2,
        4,
        5,
        6
      ],
      "NLMSB" : [
        1,
        2,
        4,
        5,
        6
      ],
      "NLOMD" : [
        1,
        2,
        4,
        5,
        6
      ],
      "NLRTM" : [
        1,
        2,
        4,
        5,
        6
      ],
      "NLURK" : [
        1,
        2,
        4,
        5,
        6
      ],
      "NLVEN" : [
        1,
        2,
        4,
        5,
        6
      ],
      "NLWKD" : [
        1,
        2,
        4,
        5,
        6
      ],
      "NLWTE" : [
        1,
        2,
        4,
        5,
        6
      ]
    },
    "authorityIdPerPort" : {
      "NLBZM" : "ATM",
      "NLHAR" : "ATM",
      "NLITR" : "ATM",
      "NLKAM" : "ATM",
      "NLLAN" : "ATM",
      "NLLWR" : "ATM",
      "NLMSB" : "ATM",
      "NLOMD" : "ATM",
      "NLRTM" : "ATM",
      "NLSCE" : "ATMG",
      "NLURK" : "ATM",
      "NLVEN" : "ATM",
      "NLWKD" : "ATM",
      "NLWTE" : "ATM"
    }
  },
  {
    "environments" : [
      "kt"
    ],
    "organisation" : {
      "fullName" : "ATM",
      "shortName" : "ATM1",
      "emailAddress" : "info@atmmoerdijk.nl",
      "address" : "Vlasweg 12",
      "city" : "Moerdijk",
      "zipCode" : "4785 PW",
      "countryUnCode" : "NL",
      "countryName" : "Netherlands",
      "phoneNumber" : "+31-168-389289",
      "faxNumber" : "+31-168-389270",
      "contact" : "Danny van Leeuwen",
      "ensEnabled" : false,
      "cargoImportEnabled" : false,
      "cargoImportEnabledByDefault" : false
    },
    "vihbNumber" : "501809",
    "collectorNumber" : "ATM01",
    "annexPerPort" : {
      "NLAMS" : [
        1,
        2,
        4,
        5,
        6
      ],
      "NLBZM" : [
        1,
        2,
        4,
        5,
        6
      ],
      "NLHAR" : [
        1,
        2,
        4,
        5,
        6
      ],
      "NLITR" : [
        1,
        2,
        4,
        5,
        6
      ],
      "NLKAM" : [
        1,
        2,
        4,
        5,
        6
      ],
      "NLLAN" : [
        1,
        2,
        4,
        5,
        6
      ],
      "NLLWR" : [
        1,
        2,
        4,
        5,
        6
      ],
      "NLMSB" : [
        1,
        2,
        4,
        5,
        6
      ],
      "NLOMD" : [
        1,
        2,
        4,
        5,
        6
      ],
      "NLRTM" : [
        1,
        2,
        4,
        5,
        6
      ],
      "NLURK" : [
        1,
        2,
        4,
        5,
        6
      ],
      "NLVEN" : [
        1,
        2,
        4,
        5,
        6
      ],
      "NLWKD" : [
        1,
        2,
        4,
        5,
        6
      ],
      "NLWTE" : [
        1,
        2,
        4,
        5,
        6
      ]
    },
    "authorityIdPerPort" : {
      "NLAMS" : "ATM",
      "NLBZM" : "ATM",
      "NLHAR" : "ATM",
      "NLITR" : "ATM",
      "NLKAM" : "ATM",
      "NLLAN" : "ATM",
      "NLLWR" : "ATM",
      "NLMSB" : "ATM",
      "NLOMD" : "ATM",
      "NLRTM" : "ATM",
      "NLSCE" : "ATMG",
      "NLURK" : "ATM",
      "NLVEN" : "ATM",
      "NLWKD" : "ATM",
      "NLWTE" : "ATM"
    }
  },
  {
    "environments" : [
      "kt"
    ],
    "organisation" : {
      "fullName" : "Bek & Verburg Rotterdam",
      "shortName" : "BEK",
      "emailAddress" : "g.eggink@gdksoftware.nl",
      "address" : "Montrealweg 100",
      "city" : "Botlek",
      "zipCode" : "3197 KH",
      "countryUnCode" : "NL",
      "countryName" : "Netherlands",
      "phoneNumber" : "+31-10-4287744",
      "faxNumber" : "+31-10-4287749",
      "contact" : "Kenny Baas",
      "ensEnabled" : false,
      "cargoImportEnabled" : false,
      "cargoImportEnabledByDefault" : false
    },
    "vihbNumber" : "500924",
    "collectorNumber" : "08G98",
    "annexPerPort" : {
      "NLAMS" : [
        1,
        2,
        4,
        5,
        6
      ],
      "NLBZM" : [
        1,
        2,
        4,
        5,
        6
      ],
      "NLDZL" : [
        5
      ],
      "NLHAR" : [
        5
      ],
      "NLITR" : [
        1,
        2,
        4,
        5,
        6
      ],
      "NLKAM" : [
        1,
        2,
        4,
        5,
        6
      ],
      "NLLAN" : [
        1,
        2,
        4,
        5,
        6
      ],
      "NLLWR" : [
        1,
        2,
        4,
        5,
        6
      ],
      "NLMSB" : [
        1,
        2,
        4,
        5,
        6
      ],
      "NLOMD" : [
        1,
        2,
        4,
        5,
        6
      ],
      "NLRTM" : [
        1,
        2,
        4,
        5,
        6
      ],
      "NLURK" : [
        1,
        2,
        4,
        5,
        6
      ],
      "NLVEN" : [
        1,
        2,
        4,
        5,
        6
      ],
      "NLWKD" : [
        1,
        2,
        4,
        5,
        6
      ],
      "NLWTE" : [
        1,
        2,
        4,
        5,
        6
      ]
    },
    "authorityIdPerPort" : {
      "NLAMS" : "BEK",
      "NLBZM" : "BEK&VERBURG",
      "NLDZL" : "BEK&VERBURG",
      "NLHAR" : "BEK&VERBURG",
      "NLITR" : "BEK&VERBURG",
      "NLKAM" : "BEK&VERBURG",
      "NLLAN" : "BEK&VERBURG",
      "NLLWR" : "BEK&VERBURG",
      "NLMSB" : "BEK&VERBURG",
      "NLOMD" : "BEK&VERBURG",
      "NLRTM" : "BEK&VERBURG",
      "NLSCE" : "BEK&VERBURG",
      "NLURK" : "BEK&VERBURG",
      "NLVEN" : "BEK&VERBURG",
      "NLWKD" : "BEK&VERBURG",
      "NLWTE" : "BEK&VERBURG"
    }
  },
  {
    "environments" : [
      "accept",
      "dev",
      "pcs",
      "prod",
      "sc"
    ],
    "organisation" : {
      "fullName" : "Bek & Verburg Rotterdam",
      "shortName" : "BEKVERBURG",
      "emailAddress" : "scheepsafvalstoffen@bek-verburg.nl",
      "address" : "Montrealweg 100",
      "city" : "Botlek",
      "zipCode" : "3197 KH",
      "countryUnCode" : "NL",
      "countryName" : "Netherlands",
      "phoneNumber" : "+31-10-4287744",
      "faxNumber" : "+31-10-4287749",
      "contact" : "Kenny Baas",
      "ensEnabled" : false,
      "cargoImportEnabled" : false,
      "cargoImportEnabledByDefault" : false
    },
    "vihbNumber" : "500924",
    "collectorNumber" : "08G98",
    "annexPerPort" : {
      "NLAMS" : [
        1,
        2,
        4,
        5,
        6
      ],
      "NLBZM" : [
        1,
        2,
        4,
        5,
        6
      ],
      "NLDHR" : [
        5
      ],
      "NLDZL" : [
        5
      ],
      "NLHAR" : [
        5
      ],
      "NLITR" : [
        1,
        2,
        4,
        5,
        6
      ],
      "NLKAM" : [
        1,
        2,
        4,
        5,
        6
      ],
      "NLLAN" : [
        1,
        2,
        4,
        5,
        6
      ],
      "NLLWR" : [
        1,
        2,
        4,
        5,
        6
      ],
      "NLMSB" : [
        1,
        2,
        4,
        5,
        6
      ],
      "NLOMD" : [
        1,
        2,
        4,
        5,
        6
      ],
      "NLRTM" : [
        1,
        2,
        4,
        5,
        6
      ],
      "NLURK" : [
        1,
        2,
        4,
        5,
        6
      ],
      "NLVEN" : [
        1,
        2,
        4,
        5,
        6
      ],
      "NLWKD" : [
        1,
        2,
        4,
        5,
        6
      ],
      "NLWTE" : [
        1,
        2,
        4,
        5,
        6
      ]
    },
    "authorityIdPerPort" : {
      "NLAMS" : "BEK",
      "NLBZM" : "BEK&VERBURG",
      "NLDHR" : "BEK&VERBURG",
      "NLDZL" : "BEK&VERBURG",
      "NLHAR" : "BEK&VERBURG",
      "NLITR" : "BEK&VERBURG",
      "NLKAM" : "BEK&VERBURG",
      "NLLAN" : "BEK&VERBURG",
      "NLLWR" : "BEK&VERBURG",
      "NLMSB" : "BEK&VERBURG",
      "NLOMD" : "BEK&VERBURG",
      "NLRTM" : "BEK&VERBURG",
      "NLSCE" : "BEK&VERBURG",
      "NLURK" : "BEK&VERBURG",
      "NLVEN" : "BEK&VERBURG",
      "NLWKD" : "BEK&VERBURG",
      "NLWTE" : "BEK&VERBURG"
    }
  },
  {
    "environments" : [
      "accept",
      "dev",
      "kt",
      "pcs",
      "prod",
      "sc"
    ],
    "organisation" : {
      "fullName" : "CIMS",
      "shortName" : "CIMS",
      "emailAddress" : "portbase@cimsnetherlands.com",
      "address" : "Boompjes 254",
      "city" : "Rotterdam",
      "zipCode" : "3011 XZ",
      "countryUnCode" : "NL",
      "countryName" : "Netherlands",
      "phoneNumber" : "+31682702949",
      "faxNumber" : "+31850711980",
      "contact" : "Barend Sleeuwenhoek",
      "ensEnabled" : false,
      "cargoImportEnabled" : false,
      "cargoImportEnabledByDefault" : false
    },
    "vihbNumber" : "530432",
    "collectorNumber" : "30432",
    "annexPerPort" : {
      "NLAMS" : [
        1,
        2,
        4,
        5,
        6
      ],
      "NLBZM" : [
        1,
        2,
        4,
        5,
        6
      ],
      "NLITR" : [
        1,
        2,
        4,
        5,
        6
      ],
      "NLKAM" : [
        1,
        2,
        4,
        5,
        6
      ],
      "NLLAN" : [
        1,
        2,
        4,
        5,
        6
      ],
      "NLLWR" : [
        1,
        2,
        4,
        5,
        6
      ],
      "NLMSB" : [
        1,
        2,
        4,
        5,
        6
      ],
      "NLOMD" : [
        1,
        2,
        4,
        5,
        6
      ],
      "NLRTM" : [
        1,
        2,
        4,
        5,
        6
      ],
      "NLURK" : [
        1,
        2,
        4,
        5,
        6
      ],
      "NLVEN" : [
        1,
        2,
        4,
        5,
        6
      ],
      "NLWKD" : [
        1,
        2,
        4,
        5,
        6
      ],
      "NLWTE" : [
        1,
        2,
        4,
        5,
        6
      ]
    },
    "authorityIdPerPort" : {
      "NLAMS" : "CIMS",
      "NLBZM" : "CIMS",
      "NLITR" : "CIMS",
      "NLKAM" : "CIMS",
      "NLLAN" : "CIMS",
      "NLLWR" : "CIMS",
      "NLMSB" : "CIMS",
      "NLOMD" : "CIMS",
      "NLRTM" : "CIMS",
      "NLURK" : "CIMS",
      "NLVEN" : "CIMS",
      "NLWKD" : "CIMS",
      "NLWTE" : "CIMS"
    }
  },
  {
    "environments" : [
      "accept",
      "dev",
      "kt",
      "pcs",
      "prod",
      "sc"
    ],
    "organisation" : {
      "fullName" : "CIMS Ship Waste Collection B.V.",
      "shortName" : "CIMSSWC",
      "emailAddress" : "portbase@cimsnetherlands.com",
      "address" : "Boompjes 254",
      "city" : "Rotterdam",
      "zipCode" : "3011 XZ",
      "countryUnCode" : "NL",
      "countryName" : "Netherlands",
      "phoneNumber" : "+31682702949",
      "faxNumber" : "+31850711980",
      "contact" : "Barend Sleeuwenhoek",
      "ensEnabled" : false,
      "cargoImportEnabled" : false,
      "cargoImportEnabledByDefault" : false
    },
    "vihbNumber" : "530432",
    "collectorNumber" : "30432",
    "annexPerPort" : {
      "NLDZL" : [
        1,
        2,
        4,
        5,
        6
      ],
      "NLEEM" : [
        1,
        2,
        4,
        5,
        6
      ]
    },
    "authorityIdPerPort" : {
      "NLDZL" : "CIMSSWC",
      "NLEEM" : "CIMSSWC"
    }
  },
  {
    "environments" : [
      "accept",
      "dev",
      "kt",
      "pcs",
      "prod",
      "sc"
    ],
    "organisation" : {
      "fullName" : "CIMS Renewables B.V.",
      "shortName" : "CIMSR",
      "emailAddress" : "Portbase@cimsrenewables.com",
      "address" : "Vrouwgelenweg 84",
      "city" : "Hendrik-Ido-Ambacht",
      "zipCode" : "3341BT",
      "countryUnCode" : "NL",
      "countryName" : "Netherlands",
      "contact" : "Mathias Braeckman",
      "ensEnabled" : false,
      "cargoImportEnabled" : false,
      "cargoImportEnabledByDefault" : false
    },
    "vihbNumber" : "537646",
    "collectorNumber" : "QUA01",
    "annexPerPort" : {
      "NLRTM" : [
        2
      ]
    },
    "authorityIdPerPort" : {
      "NLRTM" : "QUA01"
    }
  },
  {
    "environments" : [
      "accept",
      "dev",
      "kt",
      "pcs",
      "prod",
      "sc"
    ],
    "organisation" : {
      "fullName" : "Dutch Waste Collector",
      "shortName" : "DUTCHWASTE",
      "emailAddress" : "operations@dutchwaste.com",
      "address" : "Postbus 573",
      "city" : "Dordrecht",
      "zipCode" : "3330 AN",
      "countryUnCode" : "NL",
      "countryName" : "Netherlands",
      "phoneNumber" : "+31-78-6120976",
      "faxNumber" : "+31-78-6120976",
      "contact" : "Marka van den Oever",
      "ensEnabled" : false,
      "cargoImportEnabled" : false,
      "cargoImportEnabledByDefault" : false
    },
    "vihbNumber" : "5000338",
    "collectorNumber" : "08K4A",
    "annexPerPort" : {
      "NLAMS" : [
        1,
        2,
        4,
        5
      ],
      "NLBZM" : [
        1,
        5
      ],
      "NLDZL" : [
        1,
        2,
        4,
        5
      ],
      "NLITR" : [
        1,
        5
      ],
      "NLKAM" : [
        1,
        5
      ],
      "NLLAN" : [
        1,
        5
      ],
      "NLLWR" : [
        1,
        5
      ],
      "NLMSB" : [
        1,
        5
      ],
      "NLOMD" : [
        1,
        5
      ],
      "NLRTM" : [
        1,
        2,
        4,
        5,
        6
      ],
      "NLURK" : [
        1,
        5
      ],
      "NLVEN" : [
        1,
        5
      ],
      "NLWKD" : [
        1,
        5
      ],
      "NLWTE" : [
        1,
        5
      ]
    },
    "authorityIdPerPort" : {
      "NLAMS" : "DTC",
      "NLBZM" : "DTC",
      "NLDZL" : "DRECHT",
      "NLHAR" : "DTC",
      "NLITR" : "DTC",
      "NLKAM" : "DTC",
      "NLLAN" : "DTC",
      "NLLWR" : "DTC",
      "NLMSB" : "DTC",
      "NLOMD" : "DTC",
      "NLRTM" : "DTC",
      "NLSCE" : "DTC",
      "NLURK" : "DTC",
      "NLVEN" : "DTC",
      "NLWKD" : "DTC",
      "NLWTE" : "DTC"
    }
  },
  {
    "environments" : [
      "accept",
      "dev",
      "kt",
      "pcs",
      "prod",
      "sc"
    ],
    "organisation" : {
      "fullName" : "ESSO Nederland B.V.",
      "shortName" : "ESSO",
      "emailAddress" : "walter.vanderschoot@exxonmobil.com",
      "address" : "Graaf Engelbertlaan 75",
      "city" : "Breda",
      "zipCode" : "4837 DS",
      "countryUnCode" : "NL",
      "countryName" : "Netherlands",
      "phoneNumber" : "+31-76-5291212",
      "faxNumber" : "+31-76-5291128",
      "contact" : "Walter van der Schoot",
      "customsEORINumber" : "NL001027311",
      "ensEnabled" : false,
      "cargoImportEnabled" : false,
      "cargoImportEnabledByDefault" : false
    },
    "annexPerPort" : {},
    "authorityIdPerPort" : {
      "NLAMS" : "ESSO",
      "NLBZM" : "ESSO",
      "NLHAR" : "ESSO",
      "NLITR" : "ESSO",
      "NLKAM" : "ESSO",
      "NLLAN" : "ESSO",
      "NLLWR" : "ESSO",
      "NLMSB" : "ESSO",
      "NLOMD" : "ESSO",
      "NLRTM" : "ESSO",
      "NLSCE" : "ESSO",
      "NLURK" : "ESSO",
      "NLVEN" : "ESSO",
      "NLWKD" : "ESSO",
      "NLWTE" : "ESSO"
    }
  },
  {
    "environments" : [
      "accept",
      "dev",
      "kt",
      "pcs",
      "prod",
      "sc"
    ],
    "organisation" : {
      "fullName" : "Europoort Industrie Diensten",
      "shortName" : "EUROPOORT",
      "emailAddress" : "loes@e-i-d.nl",
      "address" : "Pampus 15-17",
      "city" : "Stellendam",
      "zipCode" : "3251 ND",
      "countryUnCode" : "NL",
      "countryName" : "Netherlands",
      "phoneNumber" : "(0187)-497600",
      "faxNumber" : "(0187)-497600",
      "contact" : "Paul van winden",
      "ensEnabled" : false,
      "cargoImportEnabled" : false,
      "cargoImportEnabledByDefault" : false
    },
    "vihbNumber" : "507254",
    "collectorNumber" : "08EID",
    "annexPerPort" : {
      "NLAMS" : [
        1,
        2
      ],
      "NLRTM" : [
        1,
        2,
        4,
        5,
        6
      ]
    },
    "authorityIdPerPort" : {
      "NLAMS" : "EID",
      "NLRTM" : "EID"
    }
  },
  {
    "environments" : [
      "pcs",
      "prod"
    ],
    "organisation" : {
      "fullName" : "Eco Worldwide Solutions B.V.",
      "shortName" : "EWS",
      "emailAddress" : "info.fumigation@ews-group.com",
      "address" : "Tol 14",
      "city" : "Werkendam",
      "zipCode" : "4251PX",
      "countryUnCode" : "NL",
      "countryName" : "Netherlands",
      "phoneNumber" : "0183301270",
      "contact" : "Jouke Nieuwenhuizen",
      "chamberOfCommerceNumber" : "17268139",
      "ensEnabled" : false,
      "cargoImportEnabled" : false,
      "cargoImportEnabledByDefault" : false
    },
    "vihbNumber" : "537447",
    "collectorNumber" : "10387",
    "annexPerPort" : {
      "NLRTM" : [
        5
      ]
    },
    "authorityIdPerPort" : {
      "NLRTM" : "EWS"
    }
  },
  {
    "environments" : [
      "accept",
      "dev",
      "pcs",
      "prod",
      "sc"
    ],
    "organisation" : {
      "fullName" : "Renewi",
      "shortName" : "GANSEWINKEL",
      "emailAddress" : "info@gansewinkel.nl",
      "address" : "Kreekweg 80",
      "city" : "Vlaardingen",
      "zipCode" : "3133 AZ",
      "countryUnCode" : "NL",
      "countryName" : "Netherlands",
      "phoneNumber" : "+31-800-0130",
      "faxNumber" : "+31-800-0130",
      "contact" : "Helen de Hon",
      "ensEnabled" : false,
      "cargoImportEnabled" : false,
      "cargoImportEnabledByDefault" : false
    },
    "vihbNumber" : "500800",
    "collectorNumber" : "8161",
    "annexPerPort" : {
      "NLAMS" : [
        1,
        5
      ],
      "NLBZM" : [
        5,
        6
      ],
      "NLDZL" : [
        5
      ],
      "NLHAR" : [
        1,
        5
      ],
      "NLITR" : [
        5,
        6
      ],
      "NLKAM" : [
        5,
        6
      ],
      "NLLAN" : [
        5,
        6
      ],
      "NLLWR" : [
        5,
        6
      ],
      "NLMSB" : [
        5,
        6
      ],
      "NLOMD" : [
        5,
        6
      ],
      "NLRTM" : [
        5,
        6
      ],
      "NLURK" : [
        5,
        6
      ],
      "NLVEN" : [
        5,
        6
      ],
      "NLWKD" : [
        5,
        6
      ],
      "NLWTE" : [
        5,
        6
      ]
    },
    "authorityIdPerPort" : {
      "NLAMS" : "GAZ",
      "NLBZM" : "GANSEWINKEL",
      "NLDZL" : "GANSEWINKEL",
      "NLHAR" : "GANSEWINKEL",
      "NLITR" : "GANSEWINKEL",
      "NLKAM" : "GANSEWINKEL",
      "NLLAN" : "GANSEWINKEL",
      "NLLWR" : "GANSEWINKEL",
      "NLMSB" : "GANSEWINKEL",
      "NLOMD" : "GANSEWINKEL",
      "NLRTM" : "GANSEWINKEL",
      "NLSCE" : "GANSEWINKEL",
      "NLURK" : "GANSEWINKEL",
      "NLVEN" : "GANSEWINKEL",
      "NLWKD" : "GANSEWINKEL",
      "NLWTE" : "GANSEWINKEL"
    }
  },
  {
    "environments" : [
      "accept",
      "dev",
      "kt",
      "pcs",
      "prod",
      "sc"
    ],
    "organisation" : {
      "fullName" : "G.P. Groot Inzameling en Recycling",
      "shortName" : "GPG",
      "emailAddress" : "afval@gpgroot.nl",
      "address" : "Vennewatersweg 2B",
      "city" : "Heiloo",
      "zipCode" : "1852 PT",
      "countryUnCode" : "NL",
      "countryName" : "Netherlands",
      "phoneNumber" : "+31(0)88-4720100",
      "contact" : "G.P. Groot",
      "ensEnabled" : false,
      "cargoImportEnabled" : false,
      "cargoImportEnabledByDefault" : false
    },
    "annexPerPort" : {
      "NLAMS" : [
        5
      ],
      "NLDHR" : [
        5
      ]
    },
    "authorityIdPerPort" : {
      "NLAMS" : "GPG",
      "NLBZM" : "GPG",
      "NLDHR" : "GPG",
      "NLHAR" : "GPG",
      "NLITR" : "GPG",
      "NLKAM" : "GPG",
      "NLLAN" : "GPG",
      "NLLWR" : "GPG",
      "NLMSB" : "GPG",
      "NLOMD" : "GPG",
      "NLRTM" : "GPG",
      "NLURK" : "GPG",
      "NLVEN" : "GPG",
      "NLWKD" : "GPG",
      "NLWTE" : "GPG"
    }
  },
  {
    "environments" : [
      "accept",
      "dev",
      "kt",
      "pcs",
      "prod",
      "sc"
    ],
    "organisation" : {
      "fullName" : "Icova B.V.",
      "shortName" : "ICOVA",
      "emailAddress" : "servicedesk@portinfolink.com",
      "address" : "Postbus 59372",
      "city" : "Amsterdam",
      "zipCode" : "1040 KJ",
      "countryUnCode" : "NL",
      "countryName" : "Netherlands",
      "phoneNumber" : "+31-20-4476666",
      "faxNumber" : "+31-20-4476602",
      "contact" : "service desk",
      "ensEnabled" : false,
      "cargoImportEnabled" : false,
      "cargoImportEnabledByDefault" : false
    },
    "annexPerPort" : {},
    "authorityIdPerPort" : {
      "NLAMS" : "ICO",
      "NLBZM" : "ICOVA",
      "NLHAR" : "ICOVA",
      "NLITR" : "ICOVA",
      "NLKAM" : "ICOVA",
      "NLLAN" : "ICOVA",
      "NLLWR" : "ICOVA",
      "NLMSB" : "ICOVA",
      "NLOMD" : "ICOVA",
      "NLRTM" : "ICOVA",
      "NLSCE" : "ICOVA",
      "NLURK" : "ICOVA",
      "NLVEN" : "ICOVA",
      "NLWKD" : "ICOVA",
      "NLWTE" : "ICOVA"
    }
  },
  {
    "environments" : [
      "accept",
      "dev",
      "kt",
      "pcs",
      "prod",
      "sc"
    ],
    "organisation" : {
      "fullName" : "Jongen bv",
      "shortName" : "JCJONGEN",
      "emailAddress" : "info@milieuboten.nl",
      "address" : "Uilenkade 14",
      "city" : "Zwijndrecht",
      "zipCode" : "3336 LP",
      "countryUnCode" : "NL",
      "countryName" : "Netherlands",
      "phoneNumber" : "+31-78-6123648",
      "faxNumber" : "+31-78-6123648",
      "contact" : "Barry de Geus",
      "ensEnabled" : false,
      "cargoImportEnabled" : false,
      "cargoImportEnabledByDefault" : false
    },
    "vihbNumber" : "501164",
    "collectorNumber" : "08K6R",
    "annexPerPort" : {
      "NLAMS" : [
        1,
        2,
        4,
        5
      ],
      "NLBZM" : [
        1,
        6
      ],
      "NLDZL" : [
        1,
        2,
        4,
        5
      ],
      "NLITR" : [
        1,
        6
      ],
      "NLKAM" : [
        1,
        6
      ],
      "NLLAN" : [
        1,
        6
      ],
      "NLLWR" : [
        1,
        6
      ],
      "NLMSB" : [
        1,
        6
      ],
      "NLOMD" : [
        1,
        6
      ],
      "NLRTM" : [
        1,
        2,
        4,
        5,
        6
      ],
      "NLURK" : [
        1,
        6
      ],
      "NLVEN" : [
        1,
        6
      ],
      "NLWKD" : [
        1,
        6
      ],
      "NLWTE" : [
        1,
        6
      ]
    },
    "authorityIdPerPort" : {
      "NLAMS" : "JONGEN",
      "NLBZM" : "JONGEN",
      "NLDZL" : "JONGEN",
      "NLHAR" : "JONGEN",
      "NLITR" : "JONGEN",
      "NLKAM" : "JONGEN",
      "NLLAN" : "JONGEN",
      "NLLWR" : "JONGEN",
      "NLMSB" : "JONGEN",
      "NLOMD" : "JONGEN",
      "NLRTM" : "JONGEN",
      "NLSCE" : "JONGEN",
      "NLURK" : "JONGEN",
      "NLVEN" : "JONGEN",
      "NLWKD" : "JONGEN",
      "NLWTE" : "JONGEN"
    }
  },
  {
    "environments" : [
      "accept",
      "dev",
      "kt",
      "pcs",
      "prod",
      "sc"
    ],
    "organisation" : {
      "fullName" : "Classificeerbedrijf Joosten",
      "shortName" : "JOOSTEN",
      "emailAddress" : "info@classificeerbedrijfjoosten.nl",
      "address" : "Venjelaan 17",
      "city" : "Farmsum",
      "zipCode" : "9936 BR",
      "countryUnCode" : "NL",
      "countryName" : "Netherlands",
      "phoneNumber" : "+31(0)596-618100",
      "contact" : "Classificeerbedrijf Joosten",
      "ensEnabled" : false,
      "cargoImportEnabled" : false,
      "cargoImportEnabledByDefault" : false
    },
    "annexPerPort" : {
      "NLDZL" : [
        1
      ]
    },
    "authorityIdPerPort" : {
      "NLDZL" : "JOOSTEN"
    }
  },
  {
    "environments" : [
      "accept",
      "dev",
      "kt",
      "pcs",
      "prod",
      "sc"
    ],
    "organisation" : {
      "fullName" : "Marpol",
      "shortName" : "MARPOL",
      "emailAddress" : "info@marpolservices.nl",
      "address" : "Trawlerkade 53",
      "city" : "IJmuiden",
      "zipCode" : "1976 CB",
      "countryUnCode" : "NL",
      "countryName" : "Netherlands",
      "phoneNumber" : "0255-525051",
      "faxNumber" : "0255-540508",
      "contact" : "Marpol Services",
      "ensEnabled" : false,
      "cargoImportEnabled" : false,
      "cargoImportEnabledByDefault" : false
    },
    "vihbNumber" : "513599",
    "annexPerPort" : {
      "NLAMS" : [
        1,
        2,
        4,
        5,
        6
      ],
      "NLBZM" : [
        1
      ],
      "NLDHR" : [
        1,
        2,
        4,
        5,
        6
      ],
      "NLITR" : [
        1
      ],
      "NLKAM" : [
        1
      ],
      "NLLAN" : [
        1
      ],
      "NLLWR" : [
        1
      ],
      "NLMSB" : [
        1
      ],
      "NLOMD" : [
        1
      ],
      "NLRTM" : [
        1
      ],
      "NLURK" : [
        1
      ],
      "NLVEN" : [
        1
      ],
      "NLWKD" : [
        1
      ],
      "NLWTE" : [
        1
      ]
    },
    "authorityIdPerPort" : {
      "NLAMS" : "MAL",
      "NLBZM" : "MARPOL SERVICES",
      "NLDHR" : "MARPOL SERVICES",
      "NLITR" : "MARPOL SERVICES",
      "NLKAM" : "MARPOL SERVICES",
      "NLLAN" : "MARPOL SERVICES",
      "NLLWR" : "MARPOL SERVICES",
      "NLMSB" : "MARPOL SERVICES",
      "NLOMD" : "MARPOL SERVICES",
      "NLRTM" : "MARPOL SERVICES",
      "NLURK" : "MARPOL SERVICES",
      "NLVEN" : "MARPOL SERVICES",
      "NLWKD" : "MARPOL SERVICES",
      "NLWTE" : "MARPOL SERVICES"
    }
  },
  {
    "environments" : [
      "accept",
      "dev",
      "kt",
      "pcs",
      "prod",
      "sc"
    ],
    "organisation" : {
      "fullName" : "Martens havenontvangstinstallatie Vlissingen bv",
      "shortName" : "MARTENS",
      "emailAddress" : "infom@martenscleaning.nl",
      "address" : "Spanjeweg 2",
      "city" : "Nieuwdorp",
      "zipCode" : "4455 TW",
      "countryUnCode" : "NL",
      "countryName" : "Netherlands",
      "phoneNumber" : "0113-672210",
      "faxNumber" : "0113-352442",
      "contact" : "Carlo van Stee",
      "ensEnabled" : false,
      "cargoImportEnabled" : false,
      "cargoImportEnabledByDefault" : false
    },
    "vihbNumber" : "501162",
    "collectorNumber" : "9968",
    "annexPerPort" : {
      "NLAMS" : [
        1,
        2,
        4,
        5
      ],
      "NLBZM" : [
        1,
        2,
        4,
        5,
        6
      ],
      "NLITR" : [
        1,
        2,
        4,
        5,
        6
      ],
      "NLKAM" : [
        1,
        2,
        4,
        5,
        6
      ],
      "NLLAN" : [
        1,
        2,
        4,
        5,
        6
      ],
      "NLLWR" : [
        1,
        2,
        4,
        5,
        6
      ],
      "NLMSB" : [
        1,
        2,
        4,
        5,
        6
      ],
      "NLOMD" : [
        1,
        2,
        4,
        5,
        6
      ],
      "NLRTM" : [
        1,
        2,
        4,
        5,
        6
      ],
      "NLURK" : [
        1,
        2,
        4,
        5,
        6
      ],
      "NLVEN" : [
        1,
        2,
        4,
        5,
        6
      ],
      "NLWKD" : [
        1,
        2,
        4,
        5,
        6
      ],
      "NLWTE" : [
        1,
        2,
        4,
        5,
        6
      ],
      "NLVLI" : [
        1,
        2,
        4,
        5,
        6
      ],
      "NLTNZ" : [
        1,
        2,
        4,
        5,
        6
      ]
    },
    "authorityIdPerPort" : {
      "NLAMS" : "MAT",
      "NLBZM" : "MARTENS",
      "NLITR" : "MARTENS",
      "NLKAM" : "MARTENS",
      "NLLAN" : "MARTENS",
      "NLLWR" : "MARTENS",
      "NLMSB" : "MARTENS",
      "NLOMD" : "MARTENS",
      "NLRTM" : "MARTENS",
      "NLURK" : "MARTENS",
      "NLVEN" : "MARTENS",
      "NLWKD" : "MARTENS",
      "NLWTE" : "MARTENS",
      "NLVLI" : "MARTENS",
      "NLTNZ" : "MARTENS"
    }
  },
  {
    "environments" : [
      "accept",
      "dev",
      "kt",
      "pcs",
      "prod",
      "sc"
    ],
    "organisation" : {
      "fullName" : "Martignoni Slop Disposal B.V.",
      "shortName" : "MARTIGNONI",
      "city" : "Nieuwdorp",
      "zipCode" : "4455TW",
      "countryUnCode" : "NL",
      "countryName" : "Netherlands",
      "ensEnabled" : false,
      "cargoImportEnabled" : false,
      "cargoImportEnabledByDefault" : false
    },
    "vihbNumber" : "512894",
    "annexPerPort" : {
      "NLAMS" : [
        1,
        2,
        4,
        5
      ],
      "NLBZM" : [
        1,
        2,
        4,
        5,
        6
      ],
      "NLITR" : [
        1,
        2,
        4,
        5,
        6
      ],
      "NLKAM" : [
        1,
        2,
        4,
        5,
        6
      ],
      "NLLAN" : [
        1,
        2,
        4,
        5,
        6
      ],
      "NLLWR" : [
        1,
        2,
        4,
        5,
        6
      ],
      "NLMSB" : [
        1,
        2,
        4,
        5,
        6
      ],
      "NLOMD" : [
        1,
        2,
        4,
        5,
        6
      ],
      "NLRTM" : [
        1,
        2,
        4,
        5,
        6
      ],
      "NLURK" : [
        1,
        2,
        4,
        5,
        6
      ],
      "NLVEN" : [
        1,
        2,
        4,
        5,
        6
      ],
      "NLWKD" : [
        1,
        2,
        4,
        5,
        6
      ],
      "NLWTE" : [
        1,
        2,
        4,
        5,
        6
      ]
    },
    "authorityIdPerPort" : {
      "NLAMS" : "MARTIGNONI",
      "NLBZM" : "MARTIGNONI",
      "NLITR" : "MARTIGNONI",
      "NLKAM" : "MARTIGNONI",
      "NLLAN" : "MARTIGNONI",
      "NLLWR" : "MARTIGNONI",
      "NLMSB" : "MARTIGNONI",
      "NLOMD" : "MARTIGNONI",
      "NLRTM" : "MARTIGNONI",
      "NLURK" : "MARTIGNONI",
      "NLVEN" : "MARTIGNONI",
      "NLWKD" : "MARTIGNONI",
      "NLWTE" : "MARTIGNONI"
    }
  },
  {
    "environments" : [
      "accept",
      "dev",
      "kt",
      "pcs",
      "prod",
      "sc"
    ],
    "organisation" : {
      "fullName" : "MSR",
      "shortName" : "MSR",
      "emailAddress" : "operations@msrrotterdam.nl",
      "address" : "Maassluissedijk 101",
      "city" : "Vlaardingen",
      "zipCode" : "3133 KA",
      "countryUnCode" : "NL",
      "countryName" : "Netherlands",
      "phoneNumber" : "010-3033215",
      "faxNumber" : "010-3033215",
      "contact" : "Ton van der Waardt",
      "ensEnabled" : false,
      "cargoImportEnabled" : false,
      "cargoImportEnabledByDefault" : false
    },
    "vihbNumber" : "511523",
    "collectorNumber" : "MSR01",
    "annexPerPort" : {
      "NLAMS" : [
        1,
        2,
        4,
        5,
        6
      ],
      "NLBZM" : [
        1
      ],
      "NLITR" : [
        1
      ],
      "NLKAM" : [
        1
      ],
      "NLLAN" : [
        1
      ],
      "NLLWR" : [
        1
      ],
      "NLMSB" : [
        1
      ],
      "NLOMD" : [
        1
      ],
      "NLRTM" : [
        1
      ],
      "NLURK" : [
        1
      ],
      "NLVEN" : [
        1
      ],
      "NLWKD" : [
        1
      ],
      "NLWTE" : [
        1
      ]
    },
    "authorityIdPerPort" : {
      "NLAMS" : "MSR",
      "NLBZM" : "MSR",
      "NLITR" : "MSR",
      "NLKAM" : "MSR",
      "NLLAN" : "MSR",
      "NLLWR" : "MSR",
      "NLMSB" : "MSR",
      "NLOMD" : "MSR",
      "NLRTM" : "MSR",
      "NLURK" : "MSR",
      "NLVEN" : "MSR",
      "NLWKD" : "MSR",
      "NLWTE" : "MSR"
    }
  },
  {
    "environments" : [
      "accept",
      "dev",
      "kt",
      "pcs",
      "prod",
      "sc"
    ],
    "organisation" : {
      "fullName" : "Nautilus Port Services BV",
      "shortName" : "NAUTILUS",
      "emailAddress" : "info@nps-eu.com",
      "address" : "Groenendaal 23F",
      "city" : "Rotterdam",
      "zipCode" : "3011 SK",
      "countryUnCode" : "NL",
      "countryName" : "Netherlands",
      "phoneNumber" : "010-8202231",
      "faxNumber" : "010-1111111",
      "contact" : "R. Meuldijk",
      "customsEORINumber" : "NL819529254",
      "ensEnabled" : false,
      "cargoImportEnabled" : false,
      "cargoImportEnabledByDefault" : false
    },
    "annexPerPort" : {},
    "authorityIdPerPort" : {
      "NLAMS" : "NAU",
      "NLBZM" : "NAUTILUS",
      "NLHAR" : "NAUTILUS",
      "NLITR" : "NAUTILUS",
      "NLKAM" : "NAUTILUS",
      "NLLAN" : "NAUTILUS",
      "NLLWR" : "NAUTILUS",
      "NLMSB" : "NAUTILUS",
      "NLOMD" : "NAUTILUS",
      "NLRTM" : "NAUTILUS",
      "NLURK" : "NAUTILUS",
      "NLVEN" : "NAUTILUS",
      "NLWKD" : "NAUTILUS",
      "NLWTE" : "NAUTILUS"
    }
  },
  {
    "environments" : [
      "accept",
      "dev",
      "kt",
      "pcs",
      "prod",
      "sc"
    ],
    "organisation" : {
      "fullName" : "Nature International Slop Disposal(ISD) b.v.",
      "shortName" : "NISD",
      "emailAddress" : "portbase@ngrp.com",
      "address" : "Bunschotenweg 99",
      "city" : "Rotterdam",
      "zipCode" : "3089 KB",
      "countryUnCode" : "NL",
      "countryName" : "Netherlands",
      "phoneNumber" : "085-4867222",
      "faxNumber" : "085-4867222",
      "contact" : "Rene van der Wolf",
      "ensEnabled" : false,
      "cargoImportEnabled" : false,
      "cargoImportEnabledByDefault" : false
    },
    "vihbNumber" : "501003",
    "collectorNumber" : "08KF1",
    "annexPerPort" : {
      "NLAMS" : [
        1,
        2,
        4,
        5,
        6
      ],
      "NLBZM" : [
        1,
        2,
        4,
        5,
        6
      ],
      "NLDHR" : [
        1,
        5,
        6
      ],
      "NLDZL" : [
        1,
        2,
        4,
        5,
        6
      ],
      "NLHAR" : [
        1,
        4,
        5,
        6
      ],
      "NLITR" : [
        1,
        2,
        4,
        5,
        6
      ],
      "NLKAM" : [
        1,
        2,
        4,
        5,
        6
      ],
      "NLLAN" : [
        1,
        2,
        4,
        5,
        6
      ],
      "NLLWR" : [
        1,
        2,
        4,
        5,
        6
      ],
      "NLMSB" : [
        1,
        2,
        4,
        5,
        6
      ],
      "NLOMD" : [
        1,
        2,
        4,
        5,
        6
      ],
      "NLRTM" : [
        1,
        2,
        4,
        5,
        6
      ],
      "NLURK" : [
        1,
        2,
        4,
        5,
        6
      ],
      "NLVEN" : [
        1,
        2,
        4,
        5,
        6
      ],
      "NLWKD" : [
        1,
        2,
        4,
        5,
        6
      ],
      "NLWTE" : [
        1,
        2,
        4,
        5,
        6
      ],
      "NLVLI" : [
        1,
        2,
        4,
        5,
        6
      ],
      "NLTNZ" : [
        1,
        2,
        4,
        5,
        6
      ]
    },
    "authorityIdPerPort" : {
      "NLAMS" : "ISD",
      "NLBZM" : "ISD",
      "NLDHR" : "ISD",
      "NLDZL" : "MAIN",
      "NLHAR" : "ISD",
      "NLITR" : "ISD",
      "NLKAM" : "ISD",
      "NLLAN" : "ISD",
      "NLLWR" : "ISD",
      "NLMSB" : "ISD",
      "NLOMD" : "ISD",
      "NLRTM" : "ISD",
      "NLSCE" : "ISD",
      "NLURK" : "ISD",
      "NLVEN" : "ISD",
      "NLWKD" : "ISD",
      "NLWTE" : "ISD",
      "NLVLI" : "ISD",
      "NLTNZ" : "ISD"
    }
  },
  {
    "environments" : [
      "accept",
      "dev",
      "kt",
      "pcs",
      "prod",
      "sc"
    ],
    "organisation" : {
      "fullName" : "Omega",
      "shortName" : "OMEGA",
      "emailAddress" : "notificaties@portbase.com",
      "address" : "Prisma 10",
      "city" : "Den Haag",
      "zipCode" : "2495 AR",
      "countryUnCode" : "NL",
      "countryName" : "Netherlands",
      "phoneNumber" : "070-3890824",
      "contact" : "Omega Containertransport Den Haag",
      "ensEnabled" : false,
      "cargoImportEnabled" : false,
      "cargoImportEnabledByDefault" : false
    },
    "vihbNumber" : "500234",
    "collectorNumber" : "OME01",
    "annexPerPort" : {
      "NLBZM" : [
        5
      ],
      "NLITR" : [
        5
      ],
      "NLKAM" : [
        5
      ],
      "NLLAN" : [
        5
      ],
      "NLLWR" : [
        5
      ],
      "NLMSB" : [
        5
      ],
      "NLOMD" : [
        5
      ],
      "NLRTM" : [
        5
      ],
      "NLURK" : [
        5
      ],
      "NLVEN" : [
        5
      ],
      "NLWKD" : [
        5
      ],
      "NLWTE" : [
        5
      ]
    },
    "authorityIdPerPort" : {
      "NLAMS" : "OMEGA",
      "NLBZM" : "OMEGA",
      "NLHAR" : "OMEGA",
      "NLITR" : "OMEGA",
      "NLKAM" : "OMEGA",
      "NLLAN" : "OMEGA",
      "NLLWR" : "OMEGA",
      "NLMSB" : "OMEGA",
      "NLOMD" : "OMEGA",
      "NLRTM" : "OMEGA",
      "NLSCE" : "OMEGA",
      "NLURK" : "OMEGA",
      "NLVEN" : "OMEGA",
      "NLWKD" : "OMEGA",
      "NLWTE" : "OMEGA"
    }
  },
  {
    "environments" : [
      "kt"
    ],
    "organisation" : {
      "fullName" : "Renewi",
      "shortName" : "RENEWI",
      "portAuthorityId" : "RENEWI",
      "emailAddress" : "info@gansewinkel.nl",
      "address" : "Kreekweg 80",
      "city" : "Vlaardingen",
      "zipCode" : "3133 AZ",
      "countryUnCode" : "NL",
      "countryName" : "Netherlands",
      "phoneNumber" : "+31-800-0130",
      "faxNumber" : "+31-800-0130",
      "contact" : "Helen de Hon",
      "ensEnabled" : false,
      "cargoImportEnabled" : false,
      "cargoImportEnabledByDefault" : false
    },
    "vihbNumber" : "500800",
    "collectorNumber" : "8161",
    "annexPerPort" : {
      "NLBZM" : [
        5,
        6
      ],
      "NLDZL" : [
        5
      ],
      "NLHAR" : [
        1,
        5
      ],
      "NLITR" : [
        5,
        6
      ],
      "NLKAM" : [
        5,
        6
      ],
      "NLLAN" : [
        5,
        6
      ],
      "NLLWR" : [
        5,
        6
      ],
      "NLMSB" : [
        5,
        6
      ],
      "NLOMD" : [
        5,
        6
      ],
      "NLRTM" : [
        5,
        6
      ],
      "NLURK" : [
        5,
        6
      ],
      "NLVEN" : [
        5,
        6
      ],
      "NLWKD" : [
        5,
        6
      ],
      "NLWTE" : [
        5,
        6
      ]
    },
    "authorityIdPerPort" : {
      "NLAMS" : "GAZ",
      "NLBZM" : "RENEWI",
      "NLDZL" : "RENEWI",
      "NLHAR" : "RENEWI",
      "NLITR" : "RENEWI",
      "NLKAM" : "RENEWI",
      "NLLAN" : "RENEWI",
      "NLLWR" : "RENEWI",
      "NLMSB" : "RENEWI",
      "NLOMD" : "RENEWI",
      "NLRTM" : "RENEWI",
      "NLSCE" : "RENEWI",
      "NLURK" : "RENEWI",
      "NLVEN" : "RENEWI",
      "NLWKD" : "RENEWI",
      "NLWTE" : "RENEWI"
    }
  },
  {
    "environments" : [
      "accept",
      "dev",
      "kt",
      "pcs",
      "prod",
      "sc"
    ],
    "organisation" : {
      "fullName" : "Reym BV",
      "shortName" : "REYM",
      "address" : "Nijverheidsweg 50",
      "city" : "Beverwijk",
      "zipCode" : "1948 PV",
      "countryUnCode" : "NL",
      "countryName" : "Netherlands",
      "phoneNumber" : "020-6131734",
      "faxNumber" : "020-6139154",
      "contact" : "Service Desk",
      "ensEnabled" : false,
      "cargoImportEnabled" : false,
      "cargoImportEnabledByDefault" : false
    },
    "annexPerPort" : {
      "NLAMS" : [
        1,
        2,
        5
      ],
      "NLDHR" : [
        1,
        2,
        4,
        5
      ],
      "NLDZL" : [
        2
      ],
      "NLHAR" : [
        1,
        2,
        3,
        4,
        5,
        6
      ]
    },
    "authorityIdPerPort" : {
      "NLAMS" : "REY",
      "NLDHR" : "REYM",
      "NLDZL" : "REYM",
      "NLHAR" : "RBV"
    }
  },
  {
    "environments" : [
      "accept",
      "dev",
      "kt",
      "pcs",
      "prod",
      "sc"
    ],
    "organisation" : {
      "fullName" : "SITA Recycling Services West B.V.",
      "shortName" : "SITAWEST",
      "emailAddress" : "info@sita.nl",
      "address" : "Kloosterweg 14",
      "city" : "Kapelle",
      "zipCode" : "4421 PV",
      "countryUnCode" : "NL",
      "countryName" : "Netherlands",
      "phoneNumber" : "+31-113-347400",
      "faxNumber" : "+31-113-347400",
      "contact" : "Sita User",
      "ensEnabled" : false,
      "cargoImportEnabled" : false,
      "cargoImportEnabledByDefault" : false
    },
    "annexPerPort" : {
      "NLDZL" : [
        4,
        5
      ]
    },
    "authorityIdPerPort" : {
      "NLDZL" : "SITA"
    }
  },
  {
    "environments" : [
      "accept",
      "dev",
      "kt",
      "pcs",
      "prod",
      "sc"
    ],
    "organisation" : {
      "fullName" : "Steenhuis Recycling",
      "shortName" : "STEENHUIS",
      "emailAddress" : "info@steenhuis-recycling.nl",
      "address" : "Renselweg 1a",
      "city" : "Winschoten",
      "zipCode" : "9670 AA",
      "countryUnCode" : "NL",
      "countryName" : "Netherlands",
      "phoneNumber" : "+31(0)597-412033",
      "contact" : "Steenhuis Recycling",
      "ensEnabled" : false,
      "cargoImportEnabled" : false,
      "cargoImportEnabledByDefault" : false
    },
    "annexPerPort" : {
      "NLDZL" : [
        5
      ]
    },
    "authorityIdPerPort" : {
      "NLDZL" : "STEENHUIS"
    }
  },
  {
    "environments" : [
      "kt"
    ],
    "organisation" : {
      "fullName" : "SWOC",
      "shortName" : "SWOC",
      "emailAddress" : "info@shipswaste.nl",
      "address" : "Chemieweg 10",
      "city" : "Botlek RT",
      "zipCode" : "3197 KC",
      "countryUnCode" : "NL",
      "countryName" : "Netherlands",
      "phoneNumber" : "+31-10-2957154",
      "faxNumber" : "+31-10-4162996",
      "contact" : "Edwin Michels",
      "ensEnabled" : false,
      "cargoImportEnabled" : false,
      "cargoImportEnabledByDefault" : false
    },
    "vihbNumber" : "501161",
    "collectorNumber" : "08KIH",
    "annexPerPort" : {
      "NLAMS" : [
        1,
        2,
        4,
        5
      ],
      "NLBZM" : [
        1,
        2,
        4,
        6
      ],
      "NLDZL" : [
        1,
        2,
        3,
        4,
        5,
        6
      ],
      "NLHAR" : [
        1,
        2,
        3,
        4,
        5,
        6
      ],
      "NLITR" : [
        1,
        2,
        4,
        6
      ],
      "NLKAM" : [
        1,
        2,
        4,
        6
      ],
      "NLLAN" : [
        1,
        2,
        4,
        6
      ],
      "NLLWR" : [
        1,
        2,
        4,
        6
      ],
      "NLMSB" : [
        1,
        2,
        4,
        6
      ],
      "NLOMD" : [
        1,
        2,
        4,
        6
      ],
      "NLRTM" : [
        1,
        2,
        4,
        5,
        6
      ],
      "NLURK" : [
        1,
        2,
        4,
        6
      ],
      "NLVEN" : [
        1,
        2,
        4,
        6
      ],
      "NLWKD" : [
        1,
        2,
        4,
        6
      ],
      "NLWTE" : [
        1,
        2,
        4,
        6
      ]
    },
    "authorityIdPerPort" : {
      "NLAMS" : "SWOC",
      "NLBZM" : "SWOC",
      "NLDZL" : "SWOC",
      "NLHAR" : "SWOC",
      "NLITR" : "SWOC",
      "NLKAM" : "SWOC",
      "NLLAN" : "SWOC",
      "NLLWR" : "SWOC",
      "NLMSB" : "SWOC",
      "NLOMD" : "SWOC",
      "NLRTM" : "SWOC",
      "NLSCE" : "SWOC",
      "NLURK" : "SWOC",
      "NLVEN" : "SWOC",
      "NLWKD" : "SWOC",
      "NLWTE" : "SWOC"
    }
  },
  {
    "environments" : [
      "accept",
      "dev",
      "pcs",
      "prod",
      "sc"
    ],
    "organisation" : {
      "fullName" : "SWOC",
      "shortName" : "SWOCB",
      "emailAddress" : "info@shipswaste.nl",
      "address" : "Chemieweg 10",
      "city" : "Botlek RT",
      "zipCode" : "3197 KC",
      "countryUnCode" : "NL",
      "countryName" : "Netherlands",
      "phoneNumber" : "+31-10-2957154",
      "faxNumber" : "+31-10-4162996",
      "contact" : "Edwin Michels",
      "ensEnabled" : false,
      "cargoImportEnabled" : false,
      "cargoImportEnabledByDefault" : false
    },
    "vihbNumber" : "501161",
    "collectorNumber" : "08KIH",
    "annexPerPort" : {
      "NLAMS" : [
        1,
        2,
        4,
        5
      ],
      "NLBZM" : [
        1,
        2,
        4,
        6
      ],
      "NLITR" : [
        1,
        2,
        4,
        6
      ],
      "NLKAM" : [
        1,
        2,
        4,
        6
      ],
      "NLLAN" : [
        1,
        2,
        4,
        6
      ],
      "NLLWR" : [
        1,
        2,
        4,
        6
      ],
      "NLMSB" : [
        1,
        2,
        4,
        6
      ],
      "NLOMD" : [
        1,
        2,
        4,
        6
      ],
      "NLRTM" : [
        1,
        2,
        4,
        5,
        6
      ],
      "NLURK" : [
        1,
        2,
        4,
        6
      ],
      "NLVEN" : [
        1,
        2,
        4,
        6
      ],
      "NLWKD" : [
        1,
        2,
        4,
        6
      ],
      "NLWTE" : [
        1,
        2,
        4,
        6
      ]
    },
    "authorityIdPerPort" : {
      "NLAMS" : "SWOC",
      "NLBZM" : "SWOC",
      "NLHAR" : "SWOC",
      "NLITR" : "SWOC",
      "NLKAM" : "SWOC",
      "NLLAN" : "SWOC",
      "NLLWR" : "SWOC",
      "NLMSB" : "SWOC",
      "NLOMD" : "SWOC",
      "NLRTM" : "SWOC",
      "NLSCE" : "SWOC",
      "NLURK" : "SWOC",
      "NLVEN" : "SWOC",
      "NLWKD" : "SWOC",
      "NLWTE" : "SWOC"
    }
  },
  {
    "environments" : [
      "accept",
      "dev",
      "kt",
      "pcs",
      "prod",
      "sc"
    ],
    "organisation" : {
      "fullName" : "B.V. Vacuum-Reiniging (Vacuum Cleaning)",
      "shortName" : "VACUUM",
      "emailAddress" : "info@brooms.nl",
      "address" : "Sportlaan 255",
      "city" : "Sliedrecht",
      "zipCode" : "3364 DK",
      "countryUnCode" : "NL",
      "countryName" : "Netherlands",
      "phoneNumber" : "+31-78-6106990",
      "faxNumber" : "+31-78-6295940",
      "contact" : "Peter van Gurp",
      "ensEnabled" : false,
      "cargoImportEnabled" : false,
      "cargoImportEnabledByDefault" : false
    },
    "vihbNumber" : "ZH501259VIXX",
    "collectorNumber" : "08DB5",
    "annexPerPort" : {
      "NLBZM" : [
        1,
        4
      ],
      "NLITR" : [
        1,
        4
      ],
      "NLKAM" : [
        1,
        4
      ],
      "NLLAN" : [
        1,
        4
      ],
      "NLLWR" : [
        1,
        4
      ],
      "NLMSB" : [
        1,
        4
      ],
      "NLOMD" : [
        1,
        4
      ],
      "NLRTM" : [
        1,
        2,
        4
      ],
      "NLURK" : [
        1,
        4
      ],
      "NLVEN" : [
        1,
        4
      ],
      "NLWKD" : [
        1,
        4
      ],
      "NLWTE" : [
        1,
        4
      ]
    },
    "authorityIdPerPort" : {
      "NLAMS" : "VAC",
      "NLBZM" : "VACUUMCL",
      "NLHAR" : "VACUUMCL",
      "NLITR" : "VACUUMCL",
      "NLKAM" : "VACUUMCL",
      "NLLAN" : "VACUUMCL",
      "NLLWR" : "VACUUMCL",
      "NLMSB" : "VACUUMCL",
      "NLOMD" : "VACUUMCL",
      "NLRTM" : "VACUUMCL",
      "NLSCE" : "VACUUMCL",
      "NLURK" : "VACUUMCL",
      "NLVEN" : "VACUUMCL",
      "NLWKD" : "VACUUMCL",
      "NLWTE" : "VACUUMCL"
    }
  },
  {
    "environments" : [
      "accept",
      "dev",
      "kt",
      "pcs",
      "prod",
      "sc"
    ],
    "organisation" : {
      "fullName" : "Van Hamburg Cleaning B.V.",
      "shortName" : "VANHAMBURG",
      "emailAddress" : "info@vanhamburgcleaning.nl",
      "address" : "Lorentzweg 15",
      "city" : "Spijkenisse",
      "zipCode" : "3208LJ",
      "countryUnCode" : "NL",
      "countryName" : "Netherlands",
      "phoneNumber" : "+31(0)181-612166",
      "contact" : "Remco Vercouteren",
      "chamberOfCommerceNumber" : "24210006",
      "ensEnabled" : false,
      "cargoImportEnabled" : false,
      "cargoImportEnabledByDefault" : false
    },
    "vihbNumber" : "521717",
    "collectorNumber" : "08860",
    "annexPerPort" : {
      "NLAMS" : [
        1,
        2,
        4,
        5,
        6
      ]
    },
    "authorityIdPerPort" : {
      "NLAMS" : "VHC"
    }
  },
  {
    "environments" : [
      "accept",
      "dev",
      "kt",
      "pcs",
      "prod",
      "sc"
    ],
    "organisation" : {
      "fullName" : "Verhart Groen B.V.",
      "shortName" : "VERHART",
      "emailAddress" : "notificaties@portbase.com",
      "address" : "Heeswijk 118",
      "city" : "Montfoort",
      "zipCode" : "3417 GS",
      "countryUnCode" : "NL",
      "countryName" : "Netherlands",
      "phoneNumber" : "0348-471805",
      "contact" : "Verhart Groen",
      "ensEnabled" : false,
      "cargoImportEnabled" : false,
      "cargoImportEnabledByDefault" : false
    },
    "vihbNumber" : "500347",
    "collectorNumber" : "VHG01",
    "annexPerPort" : {
      "NLAMS" : [
        5
      ],
      "NLRTM" : [
        5
      ]
    },
    "authorityIdPerPort" : {
      "NLAMS" : "RUVOMA",
      "NLBZM" : "RUVOMA",
      "NLHAR" : "RUVOMA",
      "NLITR" : "RUVOMA",
      "NLKAM" : "RUVOMA",
      "NLLAN" : "RUVOMA",
      "NLLWR" : "RUVOMA",
      "NLMSB" : "RUVOMA",
      "NLOMD" : "RUVOMA",
      "NLRTM" : "RUVOMA",
      "NLSCE" : "RUVOMA",
      "NLURK" : "RUVOMA",
      "NLVEN" : "RUVOMA",
      "NLWKD" : "RUVOMA",
      "NLWTE" : "RUVOMA"
    }
  },
  {
    "environments" : [
      "accept",
      "dev",
      "kt",
      "pcs",
      "prod",
      "sc"
    ],
    "organisation" : {
      "fullName" : "Visser Recycling",
      "shortName" : "VISSERREC",
      "emailAddress" : "notificaties@portbase.com",
      "address" : "Kelvinstraat 30",
      "city" : "Harlingen",
      "zipCode" : "8861 ND",
      "countryUnCode" : "NL",
      "countryName" : "Netherlands",
      "phoneNumber" : "+31-517-418552",
      "faxNumber" : "+31-517-418552",
      "contact" : "Service Desk",
      "ensEnabled" : false,
      "cargoImportEnabled" : false,
      "cargoImportEnabledByDefault" : false
    },
    "annexPerPort" : {
      "NLHAR" : [
        1,
        2,
        4,
        5,
        6
      ]
    },
    "authorityIdPerPort" : {
      "NLHAR" : "VISSER"
    }
  },
  {
    "environments" : [
      "accept",
      "dev",
      "kt",
      "pcs",
      "prod",
      "sc"
    ],
    "organisation" : {
      "fullName" : "Vopak Terminal Vlaardingen B.V.",
      "shortName" : "VOPAKVLD",
      "emailAddress" : "willem.nigg@vopak.com",
      "address" : "Koningin Wilhelminahaven Z.O.Z. 1",
      "city" : "Vlaardingen",
      "zipCode" : "3134 KH",
      "countryUnCode" : "NL",
      "countryName" : "Netherlands",
      "phoneNumber" : "+31-10-4608899",
      "faxNumber" : "+31-10-4604199",
      "contact" : "Vopak user",
      "customsEORINumber" : "NL001841129",
      "ensEnabled" : false,
      "cargoImportEnabled" : false,
      "cargoImportEnabledByDefault" : false
    },
    "annexPerPort" : {},
    "authorityIdPerPort" : {
      "NLAMS" : "VOPAKVLD",
      "NLHAR" : "VOPAKVLD",
      "NLITR" : "VOPAKVLD",
      "NLKAM" : "VOPAKVLD",
      "NLLAN" : "VOPAKVLD",
      "NLLWR" : "VOPAKVLD",
      "NLMSB" : "VOPAKVLD",
      "NLOMD" : "VOPAKVLD",
      "NLSCE" : "VOPAKVLD",
      "NLURK" : "VOPAKVLD",
      "NLVEN" : "VOPAKVLD",
      "NLWTE" : "VOPAKVLD"
    }
  },
  {
    "environments" : [
      "accept",
      "dev",
      "kt",
      "pcs",
      "prod",
      "sc"
    ],
    "organisation" : {
      "fullName" : "Water Afval Verwerking",
      "shortName" : "WAV",
      "emailAddress" : "info@wavboat.eu",
      "address" : "Maasboulevard 268",
      "city" : "Zwijndrecht",
      "zipCode" : "3331 ML",
      "countryUnCode" : "NL",
      "countryName" : "Netherlands",
      "phoneNumber" : "+31(0)78-6258606",
      "contact" : "Water Afval Verwerking",
      "ensEnabled" : false,
      "cargoImportEnabled" : false,
      "cargoImportEnabledByDefault" : false
    },
    "annexPerPort" : {
      "NLAMS" : [
        4
      ]
    },
    "authorityIdPerPort" : {
      "NLAMS" : "WAV",
      "NLBZM" : "WAV",
      "NLHAR" : "WAV",
      "NLITR" : "WAV",
      "NLKAM" : "WAV",
      "NLLAN" : "WAV",
      "NLLWR" : "WAV",
      "NLMSB" : "WAV",
      "NLOMD" : "WAV",
      "NLRTM" : "WAV",
      "NLURK" : "WAV",
      "NLVEN" : "WAV",
      "NLWKD" : "WAV",
      "NLWTE" : "WAV"
    }
  },
  {
    "environments" : [
      "accept",
      "dev",
      "kt",
      "pcs",
      "prod",
      "sc"
    ],
    "organisation" : {
      "fullName" : "Wenau Transport & Cleaning BV",
      "shortName" : "WENAU",
      "address" : "De Ynfeart 12",
      "city" : "Heerenveen",
      "zipCode" : "8447 GM",
      "countryUnCode" : "NL",
      "countryName" : "Netherlands",
      "phoneNumber" : "0513657900",
      "contact" : "Service Desk",
      "ensEnabled" : false,
      "cargoImportEnabled" : false,
      "cargoImportEnabledByDefault" : false
    },
    "annexPerPort" : {
      "NLDHR" : [
        1,
        2,
        4
      ],
      "NLHAR" : [
        1,
        2
      ]
    },
    "authorityIdPerPort" : {
      "NLDHR" : "WENAU",
      "NLHAR" : "WENAU"
    }
  },
  {
    "environments" : [
      "accept",
      "dev",
      "kt",
      "pcs",
      "prod",
      "sc"
    ],
    "organisation" : {
      "fullName" : "Van Winden",
      "shortName" : "WINDENCLEANING",
      "emailAddress" : "info@van-winden-cleaning.nl",
      "address" : "Dwarsweg 13",
      "city" : "Rozenburg",
      "zipCode" : "3181 HP",
      "countryUnCode" : "NL",
      "countryName" : "Netherlands",
      "phoneNumber" : "+31-181-219222",
      "faxNumber" : "+31-181-212946",
      "contact" : "Van Winden Cleaning",
      "ensEnabled" : false,
      "cargoImportEnabled" : false,
      "cargoImportEnabledByDefault" : false
    },
    "annexPerPort" : {
      "NLBZM" : [
        1,
        4
      ],
      "NLITR" : [
        1,
        4
      ],
      "NLKAM" : [
        1,
        4
      ],
      "NLLAN" : [
        1,
        4
      ],
      "NLLWR" : [
        1,
        4
      ],
      "NLMSB" : [
        1,
        4
      ],
      "NLOMD" : [
        1,
        4
      ],
      "NLRTM" : [
        1,
        4
      ],
      "NLURK" : [
        1,
        4
      ],
      "NLVEN" : [
        1,
        4
      ],
      "NLWKD" : [
        1,
        4
      ],
      "NLWTE" : [
        1,
        4
      ]
    },
    "authorityIdPerPort" : {
      "NLAMS" : "VANWINDEN",
      "NLBZM" : "VANWINDEN",
      "NLHAR" : "VANWINDEN",
      "NLITR" : "VANWINDEN",
      "NLKAM" : "VANWINDEN",
      "NLLAN" : "VANWINDEN",
      "NLLWR" : "VANWINDEN",
      "NLMSB" : "VANWINDEN",
      "NLOMD" : "VANWINDEN",
      "NLRTM" : "VANWINDEN",
      "NLSCE" : "VANWINDEN",
      "NLURK" : "VANWINDEN",
      "NLVEN" : "VANWINDEN",
      "NLWKD" : "VANWINDEN",
      "NLWTE" : "VANWINDEN"
    }
  },
  {
    "environments" : [
      "accept",
      "dev",
      "kt",
      "pcs",
      "prod",
      "sc"
    ],
    "organisation" : {
      "fullName" : "Zeeland Maritime Cleaning",
      "shortName" : "ZMC",
      "emailAddress" : "info@mzcleaning.nl",
      "address" : "Engelandweg 33",
      "city" : "Vlissingen-Oost",
      "zipCode" : "4389 PC",
      "countryUnCode" : "NL",
      "countryName" : "Netherlands",
      "phoneNumber" : "+31(0)118484038",
      "contact" : "Remco Vercouteren",
      "ensEnabled" : false,
      "cargoImportEnabled" : false,
      "cargoImportEnabledByDefault" : false
    },
    "vihbNumber" : "510589",
    "collectorNumber" : "ZL510",
    "annexPerPort" : {
      "NLAMS" : [
        1,
        2,
        4,
        5
      ],
      "NLBZM" : [
        1
      ],
      "NLITR" : [
        1
      ],
      "NLKAM" : [
        1
      ],
      "NLLAN" : [
        1
      ],
      "NLLWR" : [
        1
      ],
      "NLMSB" : [
        1
      ],
      "NLOMD" : [
        1
      ],
      "NLRTM" : [
        1,
        2,
        4,
        5,
        6
      ],
      "NLURK" : [
        1
      ],
      "NLVEN" : [
        1
      ],
      "NLWKD" : [
        1
      ],
      "NLWTE" : [
        1
      ],
      "NLVLI" : [
        1,
        2,
        4,
        5,
        6
      ],
      "NLTNZ" : [
        1,
        2,
        4,
        5,
        6
      ]
    },
    "authorityIdPerPort" : {
      "NLAMS" : "ZMC",
      "NLBZM" : "ZMC",
      "NLHAR" : "ZMC",
      "NLITR" : "ZMC",
      "NLKAM" : "ZMC",
      "NLLAN" : "ZMC",
      "NLLWR" : "ZMC",
      "NLMSB" : "ZMC",
      "NLOMD" : "ZMC",
      "NLRTM" : "ZMC",
      "NLURK" : "ZMC",
      "NLVEN" : "ZMC",
      "NLWKD" : "ZMC",
      "NLWTE" : "ZMC",
      "NLVLI" : "ZMC",
      "NLTNZ" : "ZMC"
    }
  }
]
